module.exports = __webpack_public_path__ + "media/images/emblems/Zeihen-blason-df0e1aa39994989e6489438dd4c4b6d3.png";